import { render, staticRenderFns } from "./ApplyLicense.vue?vue&type=template&id=128479a9&scoped=true"
import script from "./ApplyLicense.vue?vue&type=script&lang=js"
export * from "./ApplyLicense.vue?vue&type=script&lang=js"
import style0 from "./ApplyLicense.vue?vue&type=style&index=0&id=128479a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128479a9",
  null
  
)

export default component.exports